import { useEffect } from 'react'
import { dynamicSort } from '../../../common/Helpers';
import { getAllLE, getAllLegalEntityTypes } from '../../../services/sBook/legalEntity.service';

const useGetLegalEntitiesMaintainer = (legalEntities, setLegalEntities) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getAllLE();
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setLegalEntities(response.data);
                }
                else {
                    setLegalEntities([]);
                }
            }
            catch (error) {
                setLegalEntities([]);
            }
        }
        
        if (legalEntities === null) {
            getData()
        }
    }, [legalEntities, setLegalEntities]);
}
const useGetLegalEntities = (legalEntities, setLegalEntities) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getAllLE();
                const response = serviceResponse.data;
                const aux_array = [];

                if (response.succeeded) {
                    response.data.forEach(element => {
                        aux_array.push({
                            key: element.id,
                            value: element.id,
                            text: `${element.legalEntityCode}: ${element.name}`,
                            title: `${element.legalEntityCode}: ${element.name}`,
                            label: `${element.legalEntityCode}: ${element.name}`,
                            type: element.legalEntityTypeId})
                    });
                }

                const aux_array_ordered = aux_array.sort(dynamicSort("title"));

                setLegalEntities(aux_array_ordered);
            }
            catch (error) {
                setLegalEntities([]);
            }
        }
        
        if (legalEntities === null) {
            getData()
        }
    }, [legalEntities, setLegalEntities]);
}
const useGetLegalEntityTypes = (legalEntityTypes, setLegalEntityTypes) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getAllLegalEntityTypes();
                const response = serviceResponse.data;
                const aux_array = [];

                if (response.succeeded) {
                    response.data.forEach(element => {
                        aux_array.push({id: element.id ,  key: element.id, text: element.name, title: element.name})
                    });
                }

                setLegalEntityTypes(aux_array);
            }
            catch (error) {
                setLegalEntityTypes([]);
            }
        }
        
        if (legalEntityTypes === null) {
            getData()
        }
    }, [legalEntityTypes, setLegalEntityTypes]);
}

export {
    useGetLegalEntitiesMaintainer,
    useGetLegalEntities,
    useGetLegalEntityTypes
}